import { create } from 'zustand'
import {
  readPreferredSalonId,
  writePreferredSalonId,
  clearPreferredSalonId,
  subscribePreferredSalon,
} from '../lib/preferredSalon'

interface BookingState {
  isOpen: boolean
  preferredSalonId: string | null
  open: () => void
  close: () => void
  setPreferred: (id: string, remember: boolean) => void
  clearPreferred: () => void
}

export const useBookingStore = create<BookingState>((set) => ({
  isOpen: false,
  preferredSalonId: readPreferredSalonId(),
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  setPreferred: (id, remember) => {
    if (remember) {
      writePreferredSalonId(id)
      set({ preferredSalonId: id })
    }
  },
  clearPreferred: () => {
    clearPreferredSalonId()
    set({ preferredSalonId: null })
  },
}))

// Stay in sync with the call store (and cross-tab writes) by listening
// for shared-preference changes.
subscribePreferredSalon((id) => {
  if (useBookingStore.getState().preferredSalonId !== id) {
    useBookingStore.setState({ preferredSalonId: id })
  }
})
